import NiceModal, { useModal } from '@ebay/nice-modal-react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material'
import { CompaniesWithFullAccess } from '@shared/types/companies.types'

import { t } from 'i18next'
import { useNavigate } from 'react-router'
interface Props {
  companies: CompaniesWithFullAccess
}

export const AssignAdminModal = NiceModal.create(({ companies }: Props) => {
  const modal = useModal()
  const companyName = companies.map(c => c.name).join(', ')

  const navigate = useNavigate()
  const handleAssignAdmin = () => {
    if (companies.length === 1) {
      navigate(`/companies/${companies[0].id}/members`)
    } else {
      navigate('/companies')
    }
    modal.remove()
  }

  return (
    <>
      <Dialog
        open={modal.visible}
        onClose={() => modal.remove()}
        sx={{
          '& .MuiDialog-paper': {
            width: '37.5rem'
          }
        }}
      >
        <DialogTitle>
          <Typography variant='h6' component='span'>
            {t('modal_delete_admin.title')}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant='body1' marginBottom={'0.5rem'}>
            {t('modal_delete_admin.text', { companyName })}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button color='info' onClick={handleAssignAdmin}>
            {t('modal_delete_admin.assignAdmin')}
          </Button>
          <Button
            onClick={() => modal.remove()}
            sx={{ color: 'text.secondary' }}
          >
            {t('common.cancel')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
})
